import React from "react";
import { TextField, MenuItem, FormControl } from "@mui/material";
import { facebookDropdownStyles } from "../../../styles/textFieldStyles";

const SelectInput = ({
  id,
  label,
  name,
  value = "",
  onChange,
  required,
  helperText,
  options = [],
  disabled = false,
}) => {
  return (
    <FormControl
      fullWidth
      required={required}
      disabled={disabled}
      sx={{ mb: { xs: 1.5, sm: 2, md: 2.5 } }}
    >
      <TextField
        id={id}
        name={name}
        select
        label={label}
        value={value}
        onChange={onChange}
        helperText={helperText}
        disabled={disabled}
        fullWidth
        InputProps={{ notched: false }}
        sx={facebookDropdownStyles}
      >
        {options.length === 0 ? (
          <MenuItem value="" disabled sx={{ fontSize: "15px" }}>
            No option available
          </MenuItem>
        ) : (
          options.map((opt, index) => (
            <MenuItem key={index} value={opt.value} sx={{ fontSize: "15px", py: 1.2 }}>
              {opt.label}
            </MenuItem>
          ))
        )}
      </TextField>
    </FormControl>
  );
};

export default SelectInput;